// src/components/SelectorEmpresa.js
//
// Dialog no-cerrable que se muestra a SUPERADMIN cuando no hay
// empresa seleccionada. Bloquea la app hasta que elija una.
// También puede reabrirse desde el TopBar para cambiar.

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, Box, Typography, List, ListItem,
  ListItemButton, ListItemText, ListItemIcon, Chip, CircularProgress, Alert,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';

export default function SelectorEmpresa() {
  const { user } = useAuth();
  const {
    empresa, empresasDisponibles, seleccionarEmpresa, cargando,
  } = useApp();

  if (!user || user.entidadTipo !== 'SUPERADMIN') return null;
  if (empresa) return null;   // ya hay una elegida

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogTitle>Selecciona una empresa</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Estás entrando como <b>Superadmin</b>. Elige la empresa que quieres
          gestionar. Puedes cambiar más adelante desde el header.
        </Typography>
        {cargando && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {!cargando && empresasDisponibles?.length === 0 && (
          <Alert severity="warning">
            No hay empresas registradas. Regístrate en el sistema HolaVeci
            primero, o pide que se cree una empresa en la base de datos.
          </Alert>
        )}
        {!cargando && empresasDisponibles?.length > 0 && (
          <List>
            {empresasDisponibles.map((e) => {
              const id = e.empresaId || e.EmpresaId;
              return (
                <ListItem disablePadding key={id}>
                  <ListItemButton onClick={() => seleccionarEmpresa(id)}>
                    <ListItemIcon>
                      <StorefrontIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={e.razonSocial || e.RazonSocial || e.nombreComercial}
                      secondary={
                        <>
                          {e.nombreComercial || e.NombreComercial}
                          {' · NIT '}
                          {e.nit || e.NIT}
                        </>
                      }
                    />
                    {(e.activa || e.Activa) ? (
                      <Chip size="small" label="Activa" color="success" variant="outlined" />
                    ) : (
                      <Chip size="small" label="Inactiva" />
                    )}
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
